import { render } from "./tw-cell-edit-ag.vue?vue&type=template&id=3f77ddd0"
import script from "./tw-cell-edit-ag.vue?vue&type=script&lang=js"
export * from "./tw-cell-edit-ag.vue?vue&type=script&lang=js"
script.render = render

export default script